// extracted by mini-css-extract-plugin
export default {"colorDot":"styles_colorDot__0aLeD","optionDisabled":"styles_optionDisabled__6qbo+"};